import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import { Modal, Button } from 'antd';
import styled from 'styled-components';
import { useImportFileUrl } from './hooks/use-import-file-url.hook';
import { UrlInput } from './components/url-input.component';
import { UrlList } from './components/url-list.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(Modal).withConfig({
  displayName: "import-file-url-modalcontainer__StyledModal",
  componentId: "sc-pvvnjj-0"
})([".ant-modal-content{border-radius:16px;padding:24px;}.ant-modal-header{border-bottom:none;margin-bottom:24px;padding:0;}.ant-modal-title{font-size:24px;font-weight:700;color:#1a2140;}.ant-modal-body{padding:0;}.ant-modal-footer{border-top:none;margin-top:32px;padding:0;display:flex;justify-content:flex-end;gap:12px;}.ant-modal-close{top:24px;right:24px;}"]);
var Subtitle = styled.div.withConfig({
  displayName: "import-file-url-modalcontainer__Subtitle",
  componentId: "sc-pvvnjj-1"
})(["font-size:15px;color:#64748b;margin-top:8px;"]);
var FooterButton = styled(Button).withConfig({
  displayName: "import-file-url-modalcontainer__FooterButton",
  componentId: "sc-pvvnjj-2"
})(["height:44px;border-radius:10px;font-weight:600;padding:0 24px;"]);
var ImportButton = styled(FooterButton).withConfig({
  displayName: "import-file-url-modalcontainer__ImportButton",
  componentId: "sc-pvvnjj-3"
})(["background-color:#2563eb;border-color:#2563eb;&:hover{background-color:#1d4ed8 !important;border-color:#1d4ed8 !important;}"]);
export var ImportFileUrlModal = function ImportFileUrlModal(_ref) {
  var open = _ref.open,
      onCancel = _ref.onCancel,
      onImport = _ref.onImport,
      isImporting = _ref.isImporting,
      onDeleteFile = _ref.onDeleteFile,
      allowedFileTypes = _ref.allowedFileTypes;

  var _useImportFileUrl = useImportFileUrl(),
      urls = _useImportFileUrl.urls,
      inputValue = _useImportFileUrl.inputValue,
      handleInputChange = _useImportFileUrl.handleInputChange,
      addUrl = _useImportFileUrl.addUrl,
      removeUrl = _useImportFileUrl.removeUrl,
      clearUrls = _useImportFileUrl.clearUrls;

  var handleRemoveUrl = function handleRemoveUrl(url) {
    removeUrl(url);
    onDeleteFile === null || onDeleteFile === void 0 ? void 0 : onDeleteFile(url);
  };

  var handleImport = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var validUrls;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            validUrls = urls;

            if (allowedFileTypes && allowedFileTypes.length > 0) {
              validUrls = urls.filter(function (url) {
                return allowedFileTypes.some(function (ext) {
                  return url.toLowerCase().split('?')[0].endsWith(ext);
                });
              });
            }

            onImport(validUrls);
            clearUrls();

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [urls, allowedFileTypes, onImport, clearUrls]);

  var handleCancel = function handleCancel() {
    onCancel();
  };

  return /*#__PURE__*/_jsxs(StyledModal, {
    open: open,
    onCancel: handleCancel,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Import Files via URLs", /*#__PURE__*/_jsx(Subtitle, {
        children: "Add links to the files you want to import into your chat."
      })]
    }),
    footer: [/*#__PURE__*/_jsx(FooterButton, {
      onClick: handleCancel,
      children: "Cancel"
    }, "cancel"), /*#__PURE__*/_jsx(ImportButton, {
      type: "primary",
      onClick: handleImport,
      disabled: urls.length === 0,
      loading: isImporting,
      children: "Import Files"
    }, "import")],
    width: 560,
    centered: true,
    children: [/*#__PURE__*/_jsx(UrlInput, {
      value: inputValue,
      onChange: handleInputChange,
      onAdd: addUrl,
      disabled: isImporting
    }), /*#__PURE__*/_jsx(UrlList, {
      urls: urls,
      onRemove: handleRemoveUrl
    })]
  });
};